import { ShipperReportActions } from './ShipperReportLayout';
import { Image, Stack } from '@superdispatch/ui';
import reportConfirmationIllustration from '../assets/report-confirmation-illustration.svg';
import reportConfirmationIllustrationDark from '../assets/report-confirmation-illustration-dark.svg';
import { Typography } from '@material-ui/core';
import { Button } from '@superdispatch/ui-lab';
import styled from 'styled-components';

const ConfirmationDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 16px 24px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 16px 32px;
  }
`;

interface ShipperReportingConfirmationProps {
  onFinish: () => void;
}

export function ShipperReportingConfirmation({
  onFinish,
}: ShipperReportingConfirmationProps) {
  return (
    <>
      <ConfirmationDetails>
        <Stack align="center" space="medium">
          <Image
            src={reportConfirmationIllustration}
            srcDark={reportConfirmationIllustrationDark}
            alt="report confirmation illustration"
          />
          <Stack align="center">
            <Typography align="center" variant="h3">
              Thank you for helping us keep Super Dispatch safe
            </Typography>
            <Typography align="center">
              We take all fraud reports seriously. A member of our investigation
              team will reach out to you shortly.
            </Typography>
          </Stack>
        </Stack>
      </ConfirmationDetails>
      <ShipperReportActions>
        <Button onClick={onFinish}>Finish</Button>
      </ShipperReportActions>
    </>
  );
}
